<template>
  <v-container
    fluid
    class="panel-404 fill-height d-flex justify-center align-center flex-column flex-nowrap"
  >
    <!--    <h1 class="font-medium-96 primary&#45;&#45;text">404</h1>-->
    <v-img
      class="panel-404-img d-block flex-grow-0"
      height="55vh"
      contain
      :src="require('@/assets/image/404-3.gif')"
    />
    <h2 class="font-medium-24">{{ $t("panel.404Page.title") }}</h2>
    <p>{{ $t("panel.404Page.subtitle") }}</p>
  </v-container>
</template>
<script>
export default {
  name: "panel-404",
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss">
@import "404";
</style>
